/**
 * @method setReadiumProperty
 * @param {Element} frame
 * @param {String} property
 * @param {mixed} value
 */
const setReadiumProperty = (frame, property, value) => {
  const frameDocument = frame.contentDocument;

  // TODO: account for media dimensions in readium content
  // basically need to copy functionality from _setDimensions function in v6
  if (value === null) {
    frameDocument.documentElement.style.removeProperty(`--USER__${property}`);
    return;
  }

  frameDocument.documentElement.style.setProperty(`--USER__${property}`, value);
};

export default setReadiumProperty;
